/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { useUpdateComponent } from "cms/components/hooks/use-update-component";
import { useEffect, useState } from "react";
import { SimpliCityAdminSDK } from "@simplicitycms/simplicity-admin-js-sdk";
import { useAuth } from "cms/auth/hooks/use-auth";
import { formatTime, getMonthAndDay } from "cms/fields/fields/field-time/display/format-time";
import Config from "data/config";

const NewsAndEventsFeedComponentDisplay = () => {
    // const { component, update } = useUpdateComponent();
    const { component } = useUpdateComponent();

    // const newsLinkGuid = component?.news_link;
    // const eventsLinkGuid = component?.events_link;

    const model_selected_type = component?.model_selected_type;
    const model_selected_type_2 = component?.model_selected_type_2;
    const model_selected_type_title = component?.model_selected_type_title;
    const model_selected_type_2_title = component?.model_selected_type_2_title;

    const { token } = useAuth();
    // const [newsLink, setNewsLink] = useState(null);
    // const [eventsLink, setEventsLink] = useState(null);
    const [news, setNews] = useState([]);
    const [events, setEvents] = useState([]);

    // useEffect(() => {
    //     const fetchLinks = async () => {
    //         if (newsLinkGuid && typeof newsLinkGuid === 'string' && newsLinkGuid.length > 20) {
    //             try {
    //                 const link = await SimpliCityAdminSDK.link.findOne(token, newsLinkGuid);
    //                 setNewsLink(link);
    //             } catch (e) {
    //                 setNewsLink(null);
    //             }
    //         } else {
    //             setNewsLink(null);
    //         }
    //
    //         if (eventsLinkGuid && typeof eventsLinkGuid === 'string' && eventsLinkGuid.length > 20) {
    //             try {
    //                 const link = await SimpliCityAdminSDK.link.findOne(token, eventsLinkGuid);
    //                 setEventsLink(link);
    //             } catch (e) {
    //                 setEventsLink(null);
    //             }
    //         } else {
    //             setEventsLink(null);
    //         }
    //     };
    //     fetchLinks();
    //     // eslint-disable-next-line react-hooks/exhaustive-deps
    // }, [newsLinkGuid, eventsLinkGuid, token]);

    useEffect(() => {
        const loadNews = async () => {
            if (!model_selected_type) {
                return;
            }
            const options = {
                type: model_selected_type,
                pageSize: 4,
                pageLimit: 1,
                selected_category: "All",
                categoryName: "category",
            };
            const news = await SimpliCityAdminSDK.model.findFeed(token, options);
            if (news.results.length > 0) {
                setNews(news.results);
            } else {
                setNews([]);
            }
        };
        loadNews();
    }, [model_selected_type, token]);

    useEffect(() => {
        const loadEvents = async () => {
            const options = {
                type: model_selected_type_2,
                pageSize: 4,
                pageLimit: 1,
                selected_category: "All",
                categoryName: "category",
            };
            const events = await SimpliCityAdminSDK.model.findEventFeed(token, options);
            if (events.results.length > 0) {
                setEvents(events.results);
            } else {
                setEvents([]);
            }
        };
        loadEvents();
    }, [model_selected_type_2, token]);

    return (
        <div>
            <div className='simplicity-news-event-feed-display-wrapper'>
                <div className='section-one'>
                    <h3>{model_selected_type_title}</h3>
                    {news.length > 0 ? (
                        news.map((item, index) => (
                            <div key={index} className='news-item'>
                                <div className='news-item-date'>{formatTime(item.created_at, Config.dates.timezone, "MMM D, YYYY")}</div>
                                <div className='news-item-title'>{item.title}</div>
                            </div>
                        ))
                    ) : (
                        <p>No news available.</p>
                    )}
                </div>
                <div className='section-two'>
                    <h3>{model_selected_type_2_title}</h3>
                    {events.length > 0 ? (
                        events.map((item, index) => {
                            const eventTitle = item?.event?.Title;
                            const eventStartTime = item?.event?.StartTime;
                            const eventEndTime = item?.event?.EndTime;
                            const eventStartDate = getMonthAndDay(item?.event?.StartDate);
                            return (
                                <div key={index} className='event-item'>
                                    <div className='event-date'>
                                        <div className='event-date-month'>{eventStartDate?.month}</div>
                                        <div className='event-date-day'>{eventStartDate?.day}</div>
                                    </div>
                                    <div className='event-info'>
                                        <div className='event-title'>{eventTitle}</div>
                                        <div className='event-time'>{eventStartTime}{eventEndTime &&  `- ${eventEndTime}`}</div>
                                    </div>
                                </div>
                            );

                        })
                    ) : (
                        <p>No events available.</p>
                    )}
                </div>
            </div>
        </div>
    );
};
NewsAndEventsFeedComponentDisplay.displayName = "NewsAndEventsFeedComponentDisplay";
export { NewsAndEventsFeedComponentDisplay };
